/*
 * DifficultyBadge.tsx — 修理難易度バッジ
 * Design: テクニカル・マニュアル × ダーク精密系
 */

import type { Difficulty } from "@/lib/repairData";
import { DIFFICULTY_CONFIG } from "@/lib/repairData";

interface Props {
  difficulty: Difficulty;
  size?: "sm" | "md" | "lg";
}

export function DifficultyBadge({ difficulty, size = "sm" }: Props) {
  const cfg = DIFFICULTY_CONFIG[difficulty];
  const px = size === "sm" ? "px-2 py-0.5 text-xs" : size === "lg" ? "px-4 py-1.5 text-base font-bold" : "px-3 py-1 text-sm";

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded font-mono font-medium border whitespace-nowrap ${px} ${cfg.color} ${cfg.bg} ${cfg.border}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${cfg.dot}`} />
      難易度：{cfg.label}
    </span>
  );
}
